<div class="blogs-approach-wrapper">

    <section class="blogs-wrapper">

        <div class="blogs-heading">Integration: HubSpot HubDB Tables API 2</div>

        <div class="blogs-list">

            <div class="blog" *ngFor="let blog of tables" [routerLink]="['/blogs', blog.id]">
                <div class="blog-image"><img src="{{blog?.values?.blog_image.url}}" /></div>
                <div class="blog-name">{{ blog?.values?.blog_title }}</div>
                <div class="blog-description" [innerHTML]="blog.blogDescription"></div>
                <div class="blog-cta">
                    <a [routerLink]="['/blogs', blog.id]">Read More</a>
                </div>
            </div>
        </div>

        <div class="pre-wrapper">
            <h2>API: /cms/v3/hubdb/tables/</h2>
            <pre>{{ formatJson(tables) }}</pre>
        </div>

    </section>

</div>